<template>
  <div>
    <dialog-edit2 :value="value" @input="$emit('input')">
      <template v-slot:title>
        <small v-if="id"> ({{ id }})</small>
        {{ data.name ? data.name : "Новое задание" }}
      </template>
      <a-form-modelCols
        v-model="data"
        class="pb-1 mx-1 pt-1"
        :model="model"
        :values="data"
        :errors="errors"
        :config="config"
        @selected="onSelectField($event)"
        @validate="
          validate($event);
          doWatch($event);
        "
      />

      <template v-slot:actions>
        <a-btn-add :icon="'far fa-calendar-alt'" :title="'Расписание'" v-if="showScheduleButton()" @click="cronDialogShow = true" />
        <v-spacer></v-spacer>
        <a-btn-save
          @click="submit()"
          v-if="getAccess('task.edit', { users: [data.createdby_id, data.user_id, ...user_id] }) || !id"
          :disabled="status.status == 'ready'"
        />
        <a-btn-delete
          v-if="id && getAccess('task.delete', { data: data.status == 0 ? data : {} })"
          :disabled="status.status == 'ready'"
          @click="removeDialogShow = true"
        />
        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit2>
    <remove-dialog v-model="removeDialogShow" @remove="remove(api, id)" :title="removeTitle" />
    <cron-dialog v-model="cronDialogShow" v-if="cronDialogShow" :task="data" @link-schedule="setSchedule" />
    <su-Data
      ref="suEdit"
      v-model="suEditShow"
      api="/mechti/tasks-admin"
      :id="id"
      :activate="value"
      :dataEdit="data"
      @show="suEditShow = true"
      v-if="getAccess('suData')"
    />
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, getAccess, genModel } from "../../components/mixings";

export default {
  mixins: [getForm, submitForm, removeEl, getAccess, genModel],
  components: {
    cronDialog: () => import("./taskCronDialog"),
  },
  props: {
    value: Boolean,
    id: Number,
    object_id: Number,
    status: {
      type: Object,
      default: () => {
        return {};
      },
    },
    api: { type: String, default: "/mechti/tasks" },
  },
  data() {
    return {
      m: JSON.parse(JSON.stringify(this.$store.getters["config/get"].models.tasks)),
      removeDialogShow: false,
      removeTitle: "Вы действительно хотите удалить это задание?",
      cronDialogShow: false,
      user_id: [],
      defaults: {
        date_event: new Date(),
        is_important: 2,
        status: 0,
      },
      suEditShow: false,
      model: [],
    };
  },
  computed: {
    model1() {
      let model = JSON.parse(JSON.stringify(this.m.form));
      let status = this.data.status || 0;
      model.forEach((el) => {
        if (![0, 100, 200].includes(status) && el?.setReadonly) {
          el.readonly = true;
        }
        if (el?.sourceList) {
          //если список вариантов находится во внешнем массиве, присоединяю его
          el.options = this.m?.[el.sourceList]
            ? this.m[el.sourceList].filter((list) => {
                return !list?.hidden;
              })
            : [];
        }
      });
      return model;
    },
    config1() {
      const type = "default";
      return JSON.parse(JSON.stringify(this.m?.config?.[type] || {}));
    },
    api1() {
      return this.m?.api || null;
    },
    title() {
      return this.m?.title || "";
    },
    readonly() {
      let status = this.data.status || 0;
      if (![0, 100, 200].includes(status)) {
        //this.config.readonly = true;
        return true;
      }
      return false;
    },
    config() {
      return { dense: true, readonly: this.status.status == "ready", hideDetails: "auto" };
    },
  },
  watch: {
    id() {
      this.updateData(this.id);
    },
    "data.status"(v) {
      if (v) {
        //  this.config.readonly = true;
        //console.log("set read only");
      }
    },
    value() {
      if (this.value) {
        this.updateData(this.id);
        this.user_id.push(this.data.user_id);
        if (this.id) {
        } else {
          this.getFormModel(["status"])[0].type = "";
        }
      }
    },
  },
  created() {
    this.loaded = false;
    if (this.value) {
      this.updateData(this.id);
      if (!this.id) {
        this.loaded = true; ///  this.type = 1;
        //  this.data.status = 0;
      }
    }
  },
  methods: {
    onSelectField(e) {
      if (e.name == "type") this.data.is_important = e?.value?.priority || 10;
      if (e.name == "type") {
        if (e?.value?.users || Array.isArray(e?.value?.users)) {
          const u = e.value.users;
          let mu = this.model.find((m) => m.name == "user_id");
          mu.api.filters["id"] = u;
          if (u.length == 1) this.data.user_id = u[0];
          else {
            this.data.user_id = null;
          }
        }
      }
    },
    async setSchedule(e) {
      let data = { id: this.data.id, params: this.data.params || {} };
      data.params.schedule_id = e;
      this.loading = true;
      let response = await this.$axios.post(this.api, data);
      this.loading = false;
      let status = response.data.status == "ok";
      if (response.data.data) {
        this.$root.$emit("show-info", {
          text: "Рассписание создано успешно",
        });
      } else {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Рассписание создалось с ошибкой",
        });
      }
    },
    afterFetchData() {
      if (this.id)
        if (["construction-goods", "construction-schedule"].includes(this.data?.params?.parent)) {
          this.getFormModel(["type"])[0].hidden = true;
        }
      this.getModel();
    },
    doWatch(e) {
      if (e == this.m?.config?.watch) this.getModel(this.data?.[e]);
    },
    findConfig(t) {
      const config = this.m.config.config || [];
      for (let i = 0; i < config.length; i++) {
        const el = config[i];
        if (el.value.includes(t)) {
          return el;
        }
      }
      return null;
    },
    getModel(t) {
      let config = JSON.parse(JSON.stringify(this.config1));
      if (t !== undefined) config = this.findConfig(t) || config;
      //console.log("get model", t, config);

      let model = this.calcModelConfig(config);
      if (true)
        model.forEach((el) => {
          if (el.hiddenCreate && !this.data?.id) {
            el.hidden = true;
          }
        });
      let status = this.data.status || 0;
      if (status > 0) config.fieldsRO = "is_private";
      model.forEach((el) => {
        if (![0, 100, 200].includes(status) && el?.setReadonly) {
          el.readonly = true;
        }
      });
      this.fillFormFromModel(model);
      model = this.getFormModel(config.fieldsForm.split(","), model);
      this.model = model;
      //  this.inputData(this.initData);
    },
    afterRemove(data) {
      this.removeDialogShow = false;
      this.$emit("input");
      this.$emit("close");
    },
    afterSave(data, status) {
      if (status) this.$emit("input");
    },
    showScheduleButton(type) {
      if (!this.id) return false;

      //  if (![6, 13].includes(this.$root.profile.id)) return false;
      if (this.data.createdby_id !== this.$root.profile.id) return false;
      const types = this.$store.getters["config/get"].config.dictionary.tasksType;
      return types.find((el) => {
        return el.value == this.data.type;
      })?.canSchedule;
      return this.m.types.find((el) => {
        return el.value == this.data.type;
      })?.canSchedule;
    },
  },
};
</script>
